import { render, staticRenderFns } from "./OnlineCultureMusic.vue?vue&type=template&id=002d24c0&"
import script from "./OnlineCultureMusic.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureMusic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports